var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDanger = function SvgDanger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2.75a.458.458 0 0 1 .458.458v2.75a.458.458 0 1 1-.916 0v-2.75A.458.458 0 0 1 5.5 2.75ZM5.5 7.333a.458.458 0 1 0 0 .917.458.458 0 0 0 0-.917Z",
    fill: "#ED4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5.917a4.583 4.583 0 1 0 0 9.166 4.583 4.583 0 0 0 0-9.166ZM1.833 5.5a3.667 3.667 0 1 0 7.334 0 3.667 3.667 0 0 0-7.334 0Z",
    fill: "#ED4D4D"
  })));
};
export default SvgDanger;